import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthenticationService } from '@app/feature/authentication/service/authentication.service';
import { environment } from '@environment/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthenticationService);
  const token = authService.getToken();
  const isApiRequest = req.url.startsWith(environment.apiURL);

  if (!isApiRequest) {
    return next(req);
  }

  if (!authService.isTokenValid()) {
    return next(req.clone({ withCredentials: true }));
  }

  const authReq = req.clone({
    withCredentials: true,
    headers: req.headers.set('Authorization', `Bearer ${token}`),
  });
  return next(authReq);
};
